import { BloodGlucoseSession, Query } from "../../../misc/api/apiTypes";
import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import * as GenericMessages from '../../../misc/api/DeviceLinkApi/GenericMessages';
import * as StatStripXpress2Api from '../../../misc/api/DeviceLinkApi/StatStripXpress2';
import * as StatStripXpressMessages from '../../../misc/api/DeviceLinkApi/StatStripXpress2Messages';
import { WebPortalLegacyClientInternal } from "../../../misc/api/WebPortalTokenClient";

export const StatStripXpress2CheckExistingData = async (legacyClient: WebPortalLegacyClientInternal, device: Device, raiseConfigurationError: (message: string, isWarning: boolean) => void): Promise<boolean> => {
    const fetchParentBloodGlucoseSessions = (serialNumber: string): Promise<Query<BloodGlucoseSession>> => {
        const filters = [{
            Member: 'DeviceSerialNumber',
            Values: [serialNumber],
        },
        {
            Member: 'StatusId',
            Values: ['BGSS_AWAITING_DATA'],
        }];

        return legacyClient.getBloodGlucoseSessions({ Filters: filters });
    }

    const results = await StatStripXpress2Api.ApiGetResults(device.id);
    const sessions = await fetchParentBloodGlucoseSessions(device.serial);

    if (results.length > 0) {
        raiseConfigurationError(StatStripXpressMessages.TestsArePresentWarningMessage, true);
    }

    if (sessions.Count > 0 && results.length > 0) {
        raiseConfigurationError(GenericMessages.DataExistBlockedConfigurationMessage, false);
        return false;
    } else if (sessions.Count > 0) {
        raiseConfigurationError(StatStripXpressMessages.DeviceAlreadyConfiguredWarningMessage, true);
    }
    return true;
}
